export const pillars = ['Litigation', 'Contracts', 'Discovery', 'Intake', 'Research', 'Ops'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'The Litigation Architect (The Drafting Blueprint)',
  desc: 'Generate flawless narratives for motions, complaints, and court pleadings. Clear your docket and win cases in minutes.'
}, {
  n: 2,
  emoji: '📔',
  title: 'Contract Intelligence (The Transactional Logic)',
  desc: 'Master forensic analysis for risk detection, indemnity clauses, and risk mitigation. Never doubt your contract logic again.'
}, {
  n: 3,
  emoji: '📕',
  title: 'Discovery Engine (The Evidence Shield)',
  desc: 'An organized framework for deposition summaries, exhibit mapping, and interrogatories. Built to survive the toughest scrutiny.'
}, {
  n: 4,
  emoji: '📓',
  title: 'Intake & Research (The Pre-Trial Engine)',
  desc: 'Dominate client vetting, statutory research, and case law summaries. Turn raw data into actionable legal strategy.'
}, {
  n: 5,
  emoji: '📗',
  title: 'Persuasive Counselor (The Communication Fortress)',
  desc: 'Manage demand letters, client updates, and complex explanations in plain English. Ensure your voice is heard and understood.'
}, {
  n: 6,
  emoji: '📙',
  title: 'Law Firm Ops (The Practice Command)',
  desc: 'Internal billing logic, performance tracking, and administrative workflows. Optimize every office task that keeps you away from billable work.'
}];
export const volumeIncludes = ['Step-by-step Copy & Paste Prompts', 'Fill-in-the-blank brackets for fast customization', 'Legal terminology alignment', '"Court-Ready" verification checklists'];
export const bonuses = [{
  n: '01',
  title: 'The Zero-Error Protocol™',
  desc: 'Automate your verification process to ensure no AI hallucinations reach your final draft.',
  price: '$35',
  cover: 'https://cdn.magicpatterns.com/uploads/obqaeHs8kmub8rm1ChLNbe/ChatGPT_Image_29_sept_2026,_14_16_58.webp'
}, {
  n: '02',
  title: 'The Master Persona Setup™',
  desc: 'Configure your AI to act as a specialized Senior Partner for your specific practice area.',
  price: '$30',
  cover: 'https://cdn.magicpatterns.com/uploads/haeP76cpBN87znoLqg1dik/ChatGPT_Image_29_sept_2026,_14_16_58_(1).webp'
}, {
  n: '03',
  title: 'The Rainmaker Framework™',
  desc: 'Lead your firm with AI-driven marketing and client acquisition strategies in seconds.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/j6CbiuzbS6LemR6FhihgWV/ChatGPT_Image_29_sept_2026,_14_16_58_(2).webp'
}, {
  n: '04',
  title: 'The Secure Practice (Ethics Guide)™',
  desc: 'Instant audit checklist to ensure your AI use complies with legal ethics and confidentiality.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/9N4C8z2KYr1CqMKVjL9KRw/ChatGPT_Image_29_sept_2026,_14_16_58_(3).webp'
}];
